<template>

    <v-sheet v-if="typeDialog === 'delete'" color="bgtopology" width="90%" class="defaultCard" style="margin: 0 auto !important;">

        <h1 class="my-5"> {{ t('labels.dialogDelete')}} </h1>
        <span class="bodyTEXT">
            {{ t('labels.bodyDialog.delete') }} {{ tag }}
        </span>
        <v-divider class="my-4"></v-divider>
        <v-row :justify="smAndDown ? 'center' : 'end'" class='ma-0 mt-6 mb-2'>
            <v-btn :class="smAndDown?'ma-2':'mx-2'" color="success" @click="deleteItem()" :block="xs">{{ t('buttons.yes') }}</v-btn>           
            <v-btn :class="smAndDown?'ma-2':'mx-2'" color="red" @click="emitDialogClose()" :block="xs">{{ t('buttons.not') }}</v-btn>
        </v-row>
    </v-sheet>

    <v-sheet v-else color="bgtopology" width="100%"  class="defaultCard">
        <v-row class="ma-0" justify="space-between" style="align-items: center !important;">
            <v-col class="pa-0" cols="10">
                <v-sheet color="transparent" v-if="typeDialog === 'add'">
                    <h4 v-if="xs"> {{ t('labels.addTitle')}} </h4>
                    <h2 v-else> {{ t('labels.addTitle')}}</h2>
                </v-sheet>
                <v-sheet color="transparent" v-if="typeDialog === 'edit'">
                    <h4 v-if="xs"> {{ t('labels.editTitle')}} </h4>
                    <h2 v-else> {{ t('labels.editTitle')}}</h2>
                </v-sheet>
            </v-col>
            <v-col class="pa-0" cols="1">
                <v-btn icon="mdi-close" variant="plain" @click="emitDialogClose()"></v-btn>
            </v-col>                    
        </v-row>
        <v-divider class="mt-4 mb-7"></v-divider>
        <v-form v-model="valid" >
            <v-row>

                 <!-- IP Field -->
                 <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-text-field
                        v-model="ip"
                        :label="t('labels.ip') + ' *'"                        
                        variant="underlined"
                        density="compact"
                        :rules="errorIP"
                    ></v-text-field>
                </v-col>

                <!-- Title Field -->
                <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-text-field
                        v-model="tag"
                        :label="t('labels.name') + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-col>

                <!-- Mark Field -->
                <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="mark"
                        :items="markSelect"
                        :label="t('labels.mark')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select> 
                </v-col>

                <!-- Subtype Field -->
                <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="rol"
                        :items="subTypeSelect"
                        :label="t('labels.subtype')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>

                <!-- type Field -->
                <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="type"
                        :items="typeSelect"
                        :label="t('labels.type')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>

                <!-- snmp_conf -->
                <v-col cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="snmp_conf"
                        :items="snmpConfSelect"
                        :label="t('labels.snmp_conf')  + ' *'"
                        variant="underlined"
                        density="compact"
                    ></v-select>
                </v-col>   

                 <!-- observation Field -->
                 <v-col cols="12" sm="4" md="6" lg='6' xl="6">
                    <v-text-field
                        v-model="anotacion"
                        :label="t('labels.annotation')"
                        variant="underlined"
                        density="compact"
                        hint='Formato: {"item": "value", "item2": "value2"...}'
                    ></v-text-field>
                </v-col>

                <!-- GPS Field -->
                <v-col cols="12" class='px-2'>
                    <v-row class="ma-0">
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 pl-0 pr-2'>
                            <v-text-field
                            v-model="latitude"
                            :label="t('labels.latitude')"
                            variant="underlined"
                            density="compact"
                            :type="'number'"
                            hide-spin-buttons
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 px-2'>
                            <v-text-field
                            v-model="longitude"
                            :label="t('labels.longitude')"
                            variant="underlined"
                            density="compact"
                            :type="'number'"
                            hide-spin-buttons
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 px-2'>
                            <v-text-field
                            v-model="altitude"
                            :label="t('labels.altitude')"
                            variant="underlined"
                            density="compact"
                            :type="'number'"
                            hide-spin-buttons
                        ></v-text-field>
                        </v-col>
                    </v-row>                    
                </v-col>  

            </v-row>
            

            <!-- Edit BTN -->
            <v-row class="ma-0" v-if="typeDialog === 'edit'">
                
                <v-col :class="smAndDown ? 'pa-0' : 'pa-0 pr-2'" cols="12" sm="4">
                    <v-btn  @click="editItem()" :disabled="(!valid && valid !== null && valid !== undefined) || (disableEDTbtn && disableByIP) || disableNewEDT" :class="smAndDown ? 'mt-3' : 'mt-10'" prepend-icon="mdi-pencil" color="success" block>
                        {{ t('buttons.change' ) }}
                    </v-btn>
                </v-col>
                <v-col :class="smAndDown ? 'pa-0' : 'pa-0 pr-2'" cols="12" sm="4">
                    <v-btn @click="addItem()" :disabled="(!valid && valid !== null && valid !== undefined) || disableADDbtn" :class="smAndDown ? 'mt-3' : 'mt-10'" prepend-icon="mdi-check-circle" color="success" block>
                        {{ t('buttons.add' ) }}
                    </v-btn>
                </v-col>
                <v-col :class="smAndDown ? 'pa-0' : 'pa-0 pr-2'" cols="12" sm="4">
                    <v-btn @click="showCopyDialog()" :disabled="(!valid && valid !== null && valid !== undefined)" :class="smAndDown ? 'mt-3' : 'mt-10'" prepend-icon="mdi-check-circle" color="success" block>
                        {{ t('buttons.copy' ) }}
                    </v-btn>
                </v-col>
            </v-row>
            
            <v-btn v-if="typeDialog === 'add'" @click="addItem()" :disabled="(!valid && valid !== null && valid !== undefined) || disableADDbtn" class="mt-10" prepend-icon="mdi-check-circle" color="success" block>
                {{ t('buttons.add' ) }}
            </v-btn>
        </v-form>
    </v-sheet>
    <v-dialog v-model="copyDialog" :width="width">
        <copyComponent
        :itemObject="itemObject"
        :arraySubtype="subTypeSelect"
        :arrayType="typeSelect"
        :arrayMark="markSelect"
        :arraySNMP="snmpConfSelect"
        @closeCopyDialog="closeCopyDialog"
        />
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch, Ref, onMounted } from 'vue';
import axios from 'axios';



/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const {xs, md,smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();


/********************************
 ********** COMPONENTS **********
 *******************************/
import copyComponent from './copyComponent.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { APIS_INVENTORY } from '@/constants/apis';
import { TIMEOUTTIME } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';


const props = defineProps({
    itemObject  : { type: Object, required:true }
})
const emits = defineEmits( ['closeDialog'] );

//==================================================//
//==================== VARIABLES ===================//
//==================================================//

/**
 * Vue / Vuetify
 */

const finalItem             = computed(() => props.itemObject);
const subTypeSelect         = ref(['']);
const typeSelect            = ref(['']);
const markSelect:Ref<string[]>      = ref([]);
const snmpConfSelect:Ref<string[]>  = ref([]);

/**
 * Component
 */

const id            = ref(finalItem.value.id);
const ip            = ref(finalItem.value.ip);
const tag           = ref(finalItem.value.tag);
const mark          = ref(finalItem.value.marca);
const rol           = ref(finalItem.value.rol);
const type          = ref(finalItem.value.tipo);
const snmp_conf     = ref(finalItem.value.snmp_conf??'0');
const anotacion     = ref(finalItem.value.anotacion??'{}');
const gps           = ref(finalItem.value.gps??'{"latitud" : 0, "longitud" : 0, "altitud" : 0}');
const typeDialog    = ref(finalItem.value.typeDialog);

const latitude      = ref(JSON.parse(gps.value).latitud);
const longitude     = ref(JSON.parse(gps.value).longitud);
const altitude      = ref(JSON.parse(gps.value).altitud);

const getIPS        = computed(() => store.state.arrayListItems );

const allDataBase = [
    'cambium_data', 'clustering_data', 'eventos', 'latencia', 'LTE_data', 
    'predicciones', 'rajant_data', 'sensores', 'servidor_data', 'ubicacion_gps', 'inventario'
]

const copyDialog    = ref(false);

const newAdd        = ref(false);
const disableADDbtn = ref(true);
const disableByIP   = ref(true);
const disableNewEDT = ref(false);
const errorIP:Ref<((v: string) => string | true)[]>       = ref([])

const disableEDTbtn = computed( ()=>
    (tag.value === finalItem.value.tag &&
    mark.value === finalItem.value.marca && type.value === finalItem.value.tipo &&
    anotacion.value === finalItem.value.anotacion && snmp_conf.value === finalItem.value.snmp_conf &&
    rol.value === finalItem.value.rol && gps.value === finalItem.value.gps && latitude.value === JSON.parse(gps.value).latitud &&
    longitude.value === JSON.parse(gps.value).longitud && altitude.value === JSON.parse(gps.value).altitud) && disableByIP.value

    // latitudePAST.value      = latitude.value;
    // longitudePAST.value     = longitude.value;
    // altitudePAST.value      = altitude.value
)

// const api           = CONSTAPIS.APIS.value.general.inventory;

const params        = ref({});

const width         = computed(() => md.value?'100%':smAndDown.value?'85%':'900px');
const valid         = ref(true);
const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Send all Form Data to API
 */
const editItem = async () => {

    newAdd.value    = false;

    await getParams();
    
    await axios.post(APIS_INVENTORY.value.postEditInventoryData,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData');
            emitDialogClose();

            store.dispatch('showSnackBar', {type: 'setSnackEdit', msg: t('snackbar.edit')});


            disableNewEDT.value = false;
            
        }
        else{
            showErrorSnackBar('snackbar.errorEdit');
        }

    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorEdit');
    });
}

const addItem = async () => {
    newAdd.value    = true;

    await getParams();

    await axios.post(APIS_INVENTORY.value.postAddInventoryData,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData'); 
            store.dispatch('showSnackBar', {type: 'setSnackAdd', msg: t('snackbar.add')});
            
            disableADDbtn.value = true;
            disableByIP.value   = true;
            disableNewEDT.value = true;

        }
        else{
            showErrorSnackBar('snackbar.errorAdd');
        }
    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorAdd');
    });
}

const deleteItem = async () => {

    allDataBase.forEach(async(database:string)=> {
        let param = {
            table   : database,
            ip      : ip.value, 
            id      : id.value
        }

        await axios.post(APIS_INVENTORY.value.postDeleteInventoryData,{params:param}, { headers: { "Authorization": `Bearer ${TOKEN}` }}, ).then((response) => {
            if(!response.data.error){

                if(database === 'inventario'){
                    store.dispatch('getInventoryData'); 
                    emitDialogClose();
                    store.dispatch('showSnackBar', {type: 'setSnackDelete', msg: t('snackbar.delete')});
                }

            }
            else{
                showErrorSnackBar('snackbar.errorDelete')
            }
        })
        .catch(function (error) {
            showConsoleError(error);
            showErrorSnackBar('snackbar.errorDelete');
        });
    })
    
}


const showErrorSnackBar = (errorMsg:string) => {

    store.dispatch('showSnackBar', {type: 'setSnackError', msg: t(`${errorMsg}`)});

}


const getParams = async () => {
    let finalGPS = {
        "latitud"   : parseFloat(latitude.value),
        "longitud" : parseFloat(longitude.value),
        "altitud"  : parseFloat(altitude.value),
    }
    params.value = {
        id          : newAdd.value ? null : id.value,
        ip          : ip.value,
        tag         : tag.value,
        marca       : mark.value,
        tipo        : type.value,
        rol         : rol.value,
        snmp_conf   : parseInt(snmp_conf.value),
        anotacion   : anotacion.value,
        gps         : JSON.stringify(finalGPS),
    }
}

const emitDialogClose = () => {
    emits('closeDialog');
}


const showCopyDialog = () => {
    copyDialog.value = true;
}
const closeCopyDialog = () => {
    copyDialog.value = false;
}


watch(ip,(getIP)=>{

    if(finalItem.value.ip === getIP){
        disableADDbtn.value = true;
        disableByIP.value   = true;
    }
    else{
        let boolprev            = false;
        let finalerror:((v: string) => string | true ) []    = [
                (v:string) => !!v ||  t('labels.error.required')
        ];
        getIPS.value.find(({ip}:GENERAL_EQUIPAMENT) => {
            if(ip === getIP.toString()){
                boolprev = true;
                finalerror = [
                    (v:string) => !!v || t('labels.error.required'),
                    (v:string) => v === null  || 'IP DUPLICADA'
                ]
            }
        })
        disableADDbtn.value = boolprev;
        disableByIP.value   = boolprev;
        errorIP.value       = finalerror;
    }
})         
       
onMounted(()=> {
    
    /**
     * Capturamos el subtipo del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getSubtypeInv, { timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((subtype)=>{
        subTypeSelect.value.pop();
        subtype.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            subTypeSelect.value.push(item.name??'')
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos el tipo del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getTypeInv,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((subtype)=>{
        typeSelect.value.pop();
        subtype.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            typeSelect.value.push(item.name??'')
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos la marca del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getMarkInventory,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((mark)=>{
        mark.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            markSelect.value.push(item.name??'');
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });

    /**
     * Capturamos la configuracion SNMP del inventario y lo mandamos al SELECT respectivo
     */
    axios.get(APIS_INVENTORY.value.getSNMPInventory,{ timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } }).then((snmp)=>{
        snmp.data.forEach((item:GENERAL_EQUIPAMENT)=>{
            snmpConfSelect.value.push(item.name??'');
        })
    })
    .catch(function (error) {
        showConsoleError(error);
    });
})

</script>